import * as React from "react";

const SvgArrowRight = (props) => (
  <svg
    width={26}
    height={49}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.3 48.997c-.332 0-.665-.126-.92-.376a1.283 1.283 0 0 1 0-1.824L22.861 24.5.381 2.201a1.283 1.283 0 0 1 0-1.824 1.309 1.309 0 0 1 1.838 0l23.4 23.212c.508.503.508 1.32 0 1.823L2.22 48.624a1.3 1.3 0 0 1-.92.376l.002-.003Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrowRight;
